var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserGroupWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 1.5C4.34315 1.5 3 2.84315 3 4.5C3 5.80727 3.83616 6.91925 5.00283 7.33029C5.07424 5.18908 6.49197 3.38892 8.43649 2.74932C7.89186 1.99267 7.00346 1.5 6 1.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.10002 8.5C5.18734 8.93019 5.3299 9.34032 5.51996 9.72268C4.50283 10.0374 3.6245 10.6681 2.99963 11.5H0C0 9.84315 1.34315 8.5 3 8.5H5.10002Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 7.5C7 5.84315 8.34315 4.5 10 4.5C11.6569 4.5 13 5.84315 13 7.5C13 9.15685 11.6569 10.5 10 10.5C8.34315 10.5 7 9.15685 7 7.5Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4 14.5C4 12.8431 5.34315 11.5 7 11.5H13C14.6569 11.5 16 12.8431 16 14.5H4Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserGroupWhite);
export default __webpack_public_path__ + "static/media/user-group-white.bc68329a1a2c60c40600dbb1de1b13e2.svg";
export { ForwardRef as ReactComponent };